import moment from 'moment';
import OverlayButton from '../../../button/v2/overlay.button';
import Container from '../../../containers/container';
import { TagsContainer } from '../../../containers/tags.container';
import { FeedOptionsDropdown } from '../../../dropdown/feeds.dropdown';
import HorizontalBar from '../../../horizontalBar';
import Icon from '../../../icons/icon';
import Avatar from '../../../images/avatar';
import { HStack, VStack } from '../../../layouts/stack.layout';
import AvatarLink from '../../../link/avatar-link';
import Text from '../../../typography/v2/text';
import ExternalLinkWrapper from '../../../utility/external-link-wrapper';
import LinkToItem from '../../../utility/link-to-item';

type MediaCardProps = {
  id: string;
  avatarUrl: string;
  source?: string;
  linkToProfile?: string;
  username?: string;
  sourceUrl?: string;
};

type SocialCardProps = MediaCardProps & {
  tags: string[];
  daysAgo: Date;
  verified: boolean;
  isInternal: boolean;
};

export function MediaCardHeader(props: MediaCardProps) {
  const { avatarUrl, source, id, sourceUrl } = props;

  return (
    <HStack justify="between">
      {/* need actual logos stored in db */}
      <a href={sourceUrl} target="_blank" rel="noreferrer">
        <Avatar
          bg={source === 'Flaunt' ? 'white' : 'black'} // temp hack
          contain // temp hack
          url={avatarUrl}
          size="base"
          alt={source || ''}
        />
      </a>
      <FeedOptionsDropdown id={id} />
      <OverlayButton name="SOCIAL_FEED" id={id} />
    </HStack>
  );
}

function UserLink({
  username,
  isInternal,
  source,
}: {
  username: string;
  isInternal: boolean;
  source: string;
}) {
  return (
    <>
      {isInternal && <LinkToItem path={`/${username}`} text={`@${username}`} />}
      {!isInternal && (
        <ExternalLinkWrapper
          link={source}
          className="border-b border-transparent hover:border-off-white"
        >
          <Text variant="username" color="primary" text={`@${username}`} />
        </ExternalLinkWrapper>
      )}
    </>
  );
}

export function SocialCardHeader(props: SocialCardProps) {
  const {
    avatarUrl,
    username,
    tags,
    daysAgo,
    verified,
    id,
    isInternal,
    sourceUrl,
  } = props;

  return (
    <Container extensions="rounded-t-xl w-full">
      <HStack justify="between" extensions="w-full">
        <VStack gap="xs">
          <HStack gap="sm">
            <AvatarLink
              username={username || ''}
              isInternal={isInternal}
              avatarUrl={avatarUrl}
              source={sourceUrl || ''}
            />
            <VStack gap="xs">
              <HStack extensions="items-center" gap="xs">
                <UserLink
                  username={username || ''}
                  isInternal={isInternal}
                  source={sourceUrl || ''}
                />
                {verified && (
                  <Icon icon="verified" color="quartiary" size="sm" />
                )}
              </HStack>
              <Text variant="supplementary" text={moment(daysAgo).fromNow()} />
              <TagsContainer tags={tags} />
            </VStack>
          </HStack>
        </VStack>
        <FeedOptionsDropdown id={id} />
        <OverlayButton name="SOCIAL_FEED" id={id} />
      </HStack>
      <Container extensions="w-full pt-5">
        <HorizontalBar color="light-gray" />
      </Container>
    </Container>
  );
}
